<template>
  <form ref="formLogin" @submit.prevent="submitLogin">
    <v-text-field v-model="email" :placeholder="$t('GLOBAL.EMAIL')" :disabled="isSubmittingLogin"
                  prepend-inner-icon="far fa-at" autocomplete="email" autofocus required>
    </v-text-field>
    <div class="mt-4"></div>
    <v-text-field ref="passwordField" v-model="password" :placeholder="$t('GLOBAL.PASSWORD')" :error-messages="loginMsg" :disabled="isSubmittingLogin"
                  :type="showPassword ? 'text' : 'password'" prepend-inner-icon="far fa-lock" required>
      <template #append-inner>
        <v-btn-icon size="small" @click="showPassword = ! showPassword">
          <v-icon size="default" :icon="showPassword ? 'far fa-eye-slash' : 'far fa-eye'"></v-icon>
        </v-btn-icon>
      </template>
    </v-text-field>
    <div class="text-right">
      <v-btn variant="text" @click.prevent="$emit('navigate-section', 'password-remind')">{{ $t('LOGIN.FORGOT_PASSWORD') }}</v-btn>
    </div>
    <v-text-field v-if="showTfa" v-model="tfaCode" placeholder="2FA" :disabled="isSubmittingLogin"
                  prepend-inner-icon="far fa-phone" class="mt-2">
    </v-text-field>
    <div ref="formCaptcha" style="margin: 8px -24px 0;"></div>
    <div class="form-actions form-group text-center mt-6">
      <v-btn :disabled="isSubmittingLogin" :loading="isSubmittingLogin" type="submit" color="primary" class="px-12" rounded size="large">
        {{ $t('LOGIN.SUBMIT') }}
      </v-btn>
    </div>
  </form>
  <div class="mt-12"></div>
  <div class="mt-auto text-center">
    <v-btn v-if="! createAccountLink" variant="text" @click.prevent="$emit('navigate-section', 'register')">{{ $t('LOGIN.CREATE_ACCOUNT') }}</v-btn>
    <v-btn v-else :href="createAccountLink" target="_blank" rel="noopener" variant="text">{{ $t('LOGIN.CREATE_ACCOUNT') }}</v-btn>
  </div>
</template>

<script>
  import clientConfig from '@/client_customs/config';

  export default {
    emits: ['navigate-section'],
    data() {
      return {
        source: clientConfig.login?.integrationSource || undefined,
        createAccountLink: clientConfig.login?.createAccountLink,
        email: "",
        password: "",
        showPassword: false,
        showTfa: false, // 2FA authentification
        tfaCode: undefined,
        loginMsg: "",
        isSubmittingLogin: false,
      };
    },
    methods: {
      submitLogin() {
        this.isSubmittingLogin = true;
        const captcha = (this.$refs.formLogin.querySelector("[name='g-recaptcha-response']") || {}).value;
        this.$refs.formCaptcha.innerHTML = '';
        window.apiSrv.login({ email: this.email, password: this.password, tfa_code: this.tfaCode, captcha, source: this.source }).catch((error) => {
          this.isSubmittingLogin = false;
          this.loginMsg = error.message;

          if (error.status == 423) {
            if (error.message == 'enter tfa code') {
              this.showTfa = true;
              return;
            }
            window.apiSrv.call('auth/login/captcha').then((captchaResponse) => {
              $(this.$refs.formCaptcha).html(captchaResponse.data);
            });
          }
        });
      },
    },
  };
</script>
